import(/* webpackMode: "eager" */ "/codebuild/output/src848233733/src/medh-web/src/app/error.tsx");
